import React, { useEffect } from "react";
import { Link, useHistory, useLocation } from 'react-router-dom';
import { AdsGETApiAuth, AdsPOSTApi, AdsPUTApi } from "../../../../Constant/api";
import { slugs } from "../../../../Constant/slugs";
import { AlertComponent } from "../../../AlertComponent";
import { CustomButton } from "../../../CustomButtom";
import { CustomButtonUnSelect } from "../../../CustomButtomUnselect";
import ImageUpload from "../../../ImageUpload";
import FileUpload from "./PDFUpload";
import FileUploadReturn from "./PDFUploadReturn";
import axios from "axios";

export default function FormComponent(props) {
  const { FetchData } = props;
  const history = useHistory()
  const [ID, setID] = React.useState(FetchData.id)

  const [Title, setTitle] = React.useState(FetchData.title.rendered)
  const [SubmittedPDF, setSubmittedPDF] = React.useState(FetchData.meta.submitted_pdf)
  const [SubmittedPDFBase64, setSubmittedPDFBase64] = React.useState("")
  const [ReturnPDF, setReturnPDF] = React.useState(FetchData.meta.return_pdf)
  const [UserID, setUserID] = React.useState(FetchData.meta.user_id)
  const [UserName, setUserName] = React.useState(FetchData.meta.user_name)
  const [UserEmail, setUserEmail] = React.useState(FetchData.meta.user_email)
  const [ExamID, setExamID] = React.useState(FetchData.meta.exam_id)
  const [ExamName, setExamName] = React.useState(FetchData.meta.exam_name)
  const [ExamPDF, setExamPDF] = React.useState(FetchData.meta.exam_pdf)
  const [ExamImage, setExamImage] = React.useState(FetchData.meta.exam_image)
  const [CheckBy, setCheckBy] = React.useState(FetchData.meta.checked_by)
  const [CheckByID, setCheckByID] = React.useState(FetchData.meta.checked_by_id)
  const [SubmittedDate, setSubmittedDate] = React.useState(FetchData.meta.submitted_date)
  const [MarksObtained, setMarksObtained] = React.useState(FetchData.meta.marks_obtained)
  const [FullMarks, setFullMarks] = React.useState(FetchData.meta.full_marks)
  const [StudentRemarks, setStudentRemarks] = React.useState(FetchData.meta.student_remarks)
  const [TeacherRemarks, setTeacherRemarks] = React.useState(FetchData.meta.teacher_remarks)
  const [ExamImageModal, setExamImageModal] = React.useState(false)

  const [reload, setReload] = React.useState(false)

  const [AlertShow, setAlertShow] = React.useState(false)
  const [Alertcomp, setAlertcomp] = React.useState("")


  const EditInfo = () => {
    setReload(true)
    const data = {
      "title": Title,
      "status": "publish",
      "meta": {
        "submitted_pdf": `${SubmittedPDF}`,
        "return_pdf": `${ReturnPDF}`,
        "user_id": `${UserID}`,
        "exam_id": `${ExamID}`,
        "exam_name": `${ExamName}`,
        "exam_pdf": `${ExamPDF}`,
        "exam_image": `${ExamImage}`,
        "user_name": `${UserName}`,
        "user_email": `${UserEmail}`,
        "checked_by": `${CheckBy}`,
        "checked_by_id": `${CheckByID}`,
        "submitted_date": `${SubmittedDate}`,
        "marks_obtained": `${MarksObtained}`,
        "full_marks": `${FullMarks}`,
        "student_remarks": `${StudentRemarks}`,
        "teacher_remarks": `${TeacherRemarks}`
      }
    }

    if (ID === "")
      AdsPOSTApi(data, slugs.db_slug_written_exam_results)
        .then((res) => {
          setReload(false)
          setID(res.data.id)
          setAlertShow(true)
          setAlertcomp("Notice Added Successfully")
          history.push(`${slugs.written_exam_details}${res.data.slug}`)
        }).catch(err => {
          setReload(false)
          console.log(err)
          setAlertShow(true)
          setAlertcomp(err.response.data.message)
        })
    else
      AdsPUTApi(data, slugs.db_slug_written_exam_results, ID)
        .then((res) => {
          setReload(false)
          setAlertShow(true)
          setAlertcomp(`${Title} edited Successfully`)
        }).catch(err => {
          console.log(err)
          console.warn(err.response.data)
          console.log("Response Status: hello11", err.response.status);
          console.log("Response Headers:", err.response.headers);
          setReload(false)
          setAlertShow(true)
          setAlertcomp(err.response.data.message)
        })
  }

  useEffect(() => {
    fetchPDF()
  }, [])

  var nodejsurl = "https://real-exam.epsexam.com/base64"
  const fetchPDF = () => {
    axios({ method: "GET", url: `${nodejsurl}?url=${FetchData.meta.submitted_pdf}` })
      .then(res => {
        setSubmittedPDFBase64(res.data.data)
        console.log(res.data)
      })
  }



  return (
    <div>
      <div className="row">
        <div className="col-sm-2 col-1"></div>
        <div className="col-sm-8 col-10 form-view mb-3">
          <h4><center>Written Exam Information</center></h4>
          <table>
            <tbody>
              {/* <tr>
                <td className="col-3">Exam Title</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Title} placeholder="Title"
                    onChange={(event) => { setTitle(event.target.value) }}
                  />
                </td>
              </tr> */}
              <tr>
                <td className="col-3">Student Name</td>
                <td className="col-6">
                  <input className="input-common" disabled
                    value={UserName} placeholder="UserName"
                    onChange={(event) => { setUserName(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Student Email</td>
                <td className="col-6">
                  <input className="input-common" disabled
                    value={UserEmail} placeholder="User Email"
                    onChange={(event) => { setUserEmail(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Exam</td>
                <td className="col-6">
                  <input className="input-common" disabled
                    value={ExamName} placeholder="Exam"
                    onChange={(event) => { setExamName(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Answer PDF</td>
                <td className="col-6">
                  <FileUploadReturn
                    ImageUrl={SubmittedPDF}
                    setImageUrl={setSubmittedPDF}
                    hideClear={true}
                    Base64PDF={SubmittedPDFBase64}
                    ReturnPDF={ReturnPDF}
                    setReturnPDF={setReturnPDF}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Exam Image</td>
                <td className="col-6" onClick={() => {
                  setExamImageModal(true)
                }}>
                  {ExamImage !== "" &&
                    <img style={{ height: 100 }} src={ExamImage} />
                  }
                </td>
              </tr>
              <tr>
                <td className="col-3">Exam PDF</td>
                <td className="col-6">
                  <FileUpload
                    ImageUrl={ExamPDF}
                    setImageUrl={setExamPDF}
                    hideClear={true}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Return PDF</td>
                <td className="col-6">
                  <FileUpload
                    ImageUrl={ReturnPDF}
                    setImageUrl={setReturnPDF}
                    hideClear={false}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Checked By</td>
                <td className="col-6">
                  <input className="input-common"
                    value={CheckBy} placeholder="Checked By"
                    onChange={(event) => { setCheckBy(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Submitted Date</td>
                <td className="col-6">
                  <input className="input-common"
                    value={SubmittedDate} placeholder="Submitted Date"
                    onChange={(event) => { SubmittedDate(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Marks Obtained</td>
                <td className="col-6">
                  <input className="input-common"
                    value={MarksObtained} placeholder="Marks Obtained"
                    onChange={(event) => { setMarksObtained(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Full Marks</td>
                <td className="col-6">
                  <input className="input-common"
                    value={FullMarks} placeholder="Full Marks"
                    onChange={(event) => { setFullMarks(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Students Remarks</td>
                <td className="col-6">
                  <textarea rows={5} className="input-common"
                    value={StudentRemarks} placeholder="Students Remarks"
                    onChange={(event) => { setStudentRemarks(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Teacher Remarks</td>
                <td className="col-6">
                  <textarea rows={5} className="input-common"
                    value={TeacherRemarks} placeholder="Teacher Remarks"
                    onChange={(event) => { setTeacherRemarks(event.target.value) }}
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <div className="row center m-2">
            <div className=" col-3" style={{ padding: "0 10px" }}>
              <div className="sign-in-button-4"
                onClick={() => {
                  EditInfo()
                }}
              >
                Update Exam Results
              </div>
            </div>
          </div>
        </div>
      </div>


      {reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
      {
        AlertShow &&
        <AlertComponent Alertcomp={Alertcomp} setAlertShow={setAlertShow} />
      }
      {ExamImageModal &&
        <div className="modal"
          onClick={() => { setExamImageModal(false) }}
        >
          <img src={ExamImage} style={{ width: "100%" }} />
        </div>

      }
    </div>
  )

}

